import React, { useRef, useEffect } from 'react';
import '../../../styles/sections/hero/HeroBackgroundVideo.css';

const HeroBackgroundVideo = ({
  videoSrc,
  poster = '',
  className = '',
  height = '70vh'
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    // Try to play programmatically for Safari/iOS
    const play = async () => {
      try { await v.play(); } catch (_) {}
    };
    play();
  }, [videoSrc]);

  return (
    <section className={`hero-bg-video ${className}`} style={{ minHeight: height }}>
      <div className="hero-bg-video__media">
        <video
          ref={videoRef}
          className="hero-bg-video__video"
          src={videoSrc}
          poster={poster}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />
        <div className="hero-bg-video__overlay" />
      </div>
    </section>
  );
};

export default HeroBackgroundVideo;


